import { createContext, useContext } from "react";
import { ConversationSummary, IFreshSession } from "../components/AISupportChat/AISupportChat.types";

export interface AISupportChatContextType {
  isOpen: boolean;
  isPrelogin: boolean;
  sessionId: string;
  openChat: (isPreLogin?:boolean) => void;
  closeChat: () => void;
  conversationsList: ConversationSummary[],
  isLoadingConversations: boolean;
  isCreatingConversation: boolean;
  providerError?: string,
  createNewConversation: () => void,
  deleteConversation: (sid:string) => void,
  selectConversation: (sid:string) => void,
  freshSession: IFreshSession,
  loadConversationsList: () => Promise<void>
  updateConversationMeta: (sid: string, patch: Partial<ConversationSummary>) => void,
  removeConversationFromList: (sid: string) => void,
}

export const AISupportChatContext = createContext<AISupportChatContextType | undefined>(
  undefined
);

export const useAISupportChat = (): AISupportChatContextType => {
  const context = useContext(AISupportChatContext);
  if (!context) {
    throw new Error(
      "useAISupportChat must be used inside AISupportChatProvider"
    );
  }
  return context;
};
